// src/components/AboutAndPrincipal.js
import React from 'react';
import AboutCollege from './AboutCollege';
import PrincipalMessage from './PrincipalMessage';
import '../css/AboutAndPrincipal.css';

const AboutAndPrincipal = () => {
  return (
    <section className="about-principal-wrapper">
      <div className="left-section">
        <AboutCollege />
      </div>
      <div className="right-section">
        <PrincipalMessage />
      </div>
    </section>
  );
};

export default AboutAndPrincipal;
